import { useAppDispatch, useAppSelector } from "@builder/store/store";
import "./style.scss";
import OliverText from "@builder/components/general/OliverText";
import { useRef, useState } from "react";
import { setBuildSize, setFrameSize } from "@builder/store/slices/BuilderSlice/builderSlice";
import Icon from "@builder/components/general/Icon";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import { BuildSizes, GlobalBlockTypes } from "@common/build/types";
import { buildSizes } from "@common/build/constants";

type FrameSize = {
    name: string;
    value: {
        x: number;
        y: number | "fit-content";
    };
};

const FrameSize: React.FC = () => {
    const dispatch = useAppDispatch();
    // const frameSize = useAppSelector(getFrameSize);
    const buildSize = useAppSelector(state => state.builder.build.size);
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const recieptSizes = Object.fromEntries(
        Object.entries(buildSizes).filter(([_, value]) => value.grouping === "1" && value.type === GlobalBlockTypes.GB_PRINT)
    );
    const labelSizes = Object.fromEntries(
        Object.entries(buildSizes).filter(([_, value]) => value.grouping === "2" && value.type === GlobalBlockTypes.GB_PRINT)
    );

    useOutsideClick(menuRef, () => {
        setMenuOpen(false);
    });

    const handleFrameSizeChange = (e: React.MouseEvent<HTMLButtonElement>) => {
        const dataKey = e.currentTarget.getAttribute("data-key") as BuildSizes;
        if (dataKey) {
            const newFrameSize = buildSizes[dataKey];
            if (newFrameSize) {
                if (dataKey !== buildSize.key) {
                    dispatch(setFrameSize(newFrameSize.value));
                    dispatch(setBuildSize({ key: dataKey }));
                }
            }
        }
    };

    return (
        <div className="frame-size-print-wrapper" ref={menuRef}>
            <button className={menuOpen ? "menu-open" : ""} onClick={() => setMenuOpen(!menuOpen)}>
                <Icon src="./print-button-icon.svg" className="frame-menu-icon" />
                <OliverText
                    text={buildSizes[buildSize.key]?.label || "Error"}
                    color="base-grey"
                    size="s"
                    weight="medium"
                    className="frame-menu-text"
                />
            </button>
            {menuOpen && (
                <div className="frame-size-menu">
                    <div className="left-col">
                        <OliverText text="Print formats" size="xxs" weight="semi-bold" color="base-blue" translatePrefix="frameSize."></OliverText>
                        {Object.entries(recieptSizes).map(([key, size], index) => (
                            <button key={index} data-key={key} onClick={handleFrameSizeChange}>
                                <OliverText text={size.label} size="s" color={key === buildSize.key ? "blue" : "base-blue"} />
                                <OliverText text="Print" size="xs" color="base-grey" />
                            </button>
                        ))}
                    </div>
                    <div className="right-col">
                        <OliverText text="Labels" size="xxs" weight="semi-bold" color="base-blue" translatePrefix="frameSize."></OliverText>
                        {Object.entries(labelSizes).map(([key, size], index) => (
                            <button key={index} data-key={key} onClick={handleFrameSizeChange}>
                                <OliverText text={size.label} size="s" color={key === buildSize.key ? "blue" : "base-blue"} />
                                <OliverText text="Label" size="xs" color="base-grey" translatePrefix="frameSize." />
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FrameSize;
